import { useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ScrollToTop from "@/components/shared/ScrollToTop";

import Header from "./Header";
import Footer from "./Footer";

const UserLayout = () => {
  const mainRef = useRef(null);
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  // Check route is login route or not

  return (
    <>
      {/* Scroll to Top */}
      <ScrollToTop containerRef={mainRef} />

      <div className={`public-layout ${isLandingPage ? "landing-page " : ""}h-screen flex flex-col overflow-hidden`}>
        {/* Render header on all routes except login */}
        <Header />

        <main className="flex-1 flex flex-col overflow-y-auto" ref={mainRef}>
          {/* Page Main Content */}
          <div className="flex-1">
            <Outlet />
          </div>

          {/* Footer */}
          <Footer />
        </main>
      </div>
    </>
  );
};

export default UserLayout;
